import FeatureCard from "./FeatureCard";
import { Wand2, Scissors, Library, Download } from "lucide-react";

const features = [
  {
    icon: Scissors,
    title: "Real-Time Editing",
    description: "Cut, trim, and arrange your footage instantly with our blazing-fast editor."
  },
  {
    icon: Library,
    title: "Pro Templates",
    description: "Choose from 100+ stunning presets and intros for any project or platform."
  },
  {
    icon: Wand2,
    title: "AI Video Magic",
    description: "Auto-enhance, add subtitles, and create highlights with one click."
  },
  {
    icon: Download,
    title: "Export Effortlessly",
    description: "Download in HD or publish directly to social media in seconds."
  }
];

const Features = () => (
  <section className="max-w-6xl mx-auto px-4 py-12">
    <h2 className="text-2xl md:text-4xl font-bold tracking-tight text-center mb-10">
      Everything You Need to Edit Like a Pro
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
      {features.map((feature) => (
        <FeatureCard key={feature.title} {...feature} />
      ))}
    </div>
  </section>
);

export default Features;
